module.exports = __webpack_public_path__ + "img/mongodb.9b024a60.jpg";